import React, { forwardRef, useMemo } from 'react';
import { OverlayHighlight, OverlayHighlightHandle } from '../OverlayHighlight';
import { intl } from '@fullstory/intl';

interface ConversionRateZoneHighlightProps extends React.ComponentProps<typeof OverlayHighlight> {
  conversionRate: number;
  hideText?: boolean;
  selected?: boolean;
}

export const ConversionRateZonedHighlight = forwardRef<
  OverlayHighlightHandle,
  ConversionRateZoneHighlightProps
>(({ conversionRate, hovering, hideText, selected, ...overlayHighlightProps }, forwardRef) => {
  const highlightText = useMemo(
    () =>
      intl.formatNumber(conversionRate, {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }),
    [conversionRate, forwardRef],
  );

  return (
    <OverlayHighlight
      data-component="ConversionRateZonedHighlight"
      {...overlayHighlightProps}
      ref={forwardRef}
      hovering={hovering}
      tooltipOpen={selected}
    >
      {!hideText && highlightText}
    </OverlayHighlight>
  );
});

ConversionRateZonedHighlight.displayName = 'ConversionRateZonedHighlight';
